import axios from 'axios';
import API from './API';

export const Logs_Get_All = () => {
  const Token = localStorage.getItem("Token");
  return API.get(`Logs/Get_All`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Logs_Get = (Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Logs/Get`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Logs_Trail_Get = (Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Logs/Get_Trail`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Logs_Reservation_Trail_Get = (Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Logs/Get_Trail_Reservation`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};